module.exports = __webpack_public_path__ + "4e116b9ebadc8570675ba930b76ab427.jpg";